import React from 'react';
import classnames from 'classnames';
import { translucent, clickable } from 'scy/utils.mod.scss';
import { gridItem } from '../styles.mod.scss';

export default function ItemContainer({
  soldout,
  children,
  className,
  onClick,
  ...props
}) {
  return (
    <div
      className={classnames(
        gridItem,
        { [translucent]: soldout, [clickable]: !!onClick },
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
}
